import Vue from 'vue'

export default {
	auth_request(state){
		state.status = 'loading'
		console.log(localStorage)
	},
	auth_success(state, token, user){
		console.log('auth : ', state, token, user);
		state.status = 'success'
		state.token = token
		state.user = token
		if (token && token.email){
			state.adminEmail = token.email;
		}
	},
	auth_error(state){
		state.status = 'error'
	},
	logout(state){
		state.status = ''
		state.token = ''
	},

	ACTIVATE_ADMIN(state){
		state.isAdmin = true
	},
	SET_ACTIVE_RESOURCE: (state, { resource, params, resourceId }) => {
		console.log('Setting active resource... ', resource)
		state.activeResource = resource
		state.activeParams = params
		state.activeResourceId = resourceId
	},

	SET_LISTS: (state, { resource, resourceOut }) => {
		console.log('SET_LISTS : ',resource, resourceOut.data.length)
		state.lists[resource] = resourceOut
	},

	SET_ACTIVE_TRANSACTION: (state, { transaction }) => {
		console.log('SET_ACTIVE_TRANSACTION : ',transaction)
		state.transaction = transaction
	},

	SET_ITEMS: (state, { items }) => {
		// console.log(items);
		items.forEach(item => {
			if (item) {
				Vue.set(state.items, item.id, item)
			}
		})
	},

	SET_USER: (state, { id, user }) => {
		var userData = user.data[0];
		var _profile = {
			memberId : userData.id,
			memberLanguage : userData.zmemLanguage,
			profileComplete : false,
			phoneVerified : false,
			registeredEvents : {},
			readyToRegister : false
		};
		// console.log('aaaaaaaaa ', state);
		if (user.linked){
			if (user.linked.mbspZmemId&&user.linked.mbspZmemId[0]){
				_profile.phoneData = user.linked.mbspZmemId[0];
				if (user.linked.mbspZmemId[0].mbspStatus==1){
					_profile.phoneVerified = true;
				}
			}
			if (user.linked.mbsdZmemId&&user.linked.mbsdZmemId[0]){
				_profile.profileComplete = true;
				_profile.profileData = user.linked.mbsdZmemId[0];
				if (_profile.profileData.mbsdStatus > 0){
					_profile.readyToRegister = true;
				}
			}
			if (user.linked.mregZmemId&&user.linked.mregZmemId.length > 0){
				user.linked.mregZmemId.forEach((event)=>{
					_profile.registeredEvents[event.mregEventId] = event;
				})
				// _profile.registeredEvents = user.linked.mregZmemId;
			}
			if (user.linked.mmedZmemId&&user.linked.mmedZmemId[0]){
				_profile.otherInfo = user.linked.mmedZmemId[0];
			}
			if (user.linked.mmfrZmemId&&user.linked.mmfrZmemId[0]){
				_profile.fastRunnerInfo = user.linked.mmfrZmemId[0];
			}
		}
		// console.log('this is user : ', _profile, user);
		state.user = _profile;
		// Vue.set(state.user, id, _profile || false) /* false means user not found */
	}
}



// WEBPACK FOOTER //
// src/store/mutations.js